/**
 * <facet-search> — searchbox client-side qui filtre les <li> checkboxes d'un facet.
 *
 * Usage :
 *   <facet-search data-target-list="facet-options-list-3">
 *     <input class="facet-search-input" type="search" ...>
 *     <button class="facet-search-clear" hidden>...</button>
 *   </facet-search>
 *
 * Comportement :
 * - Input → masque (.facet-search-hidden) les <li> dont le label ne match pas le query
 * - Le bouton "clear" apparaît dès qu'il y a un query, vide l'input au clic
 * - Force l'expansion de la liste si elle était collapsed (aria-expanded)
 * - stopPropagation sur tous les events input/keydown pour ne pas déclencher
 *   FacetFiltersForm (qui submit le form sur input → reload de la collection)
 */
(function () {
  'use strict';

  class FacetSearch extends HTMLElement {
    constructor() {
      super();
      this.handleInput = this.handleInput.bind(this);
      this.handleKey = this.handleKey.bind(this);
      this.handleClear = this.handleClear.bind(this);
    }

    connectedCallback() {
      this.input = this.querySelector('.facet-search-input');
      this.clearBtn = this.querySelector('.facet-search-clear');
      this.targetListId = this.dataset.targetList;
      this.targetList = this.targetListId
        ? document.getElementById(this.targetListId)
        : null;

      if (!this.input || !this.targetList) return;

      // Listen only on the input itself. handleInput/handleKey call
      // event.stopPropagation() internally to keep FacetFiltersForm from
      // catching the event and submitting the collection form.
      // (Previously I added a capture-phase listener on `this` which
      // prevented the event from ever reaching the input in the target
      // phase — bug fixed.)
      this.input.addEventListener('input', this.handleInput);
      this.input.addEventListener('keydown', this.handleKey);
      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', this.handleClear);
      }
    }

    handleInput(event) {
      event.stopPropagation();
      const query = this.input.value.trim().toLowerCase();
      this.filterItems(query);
      if (this.clearBtn) {
        this.clearBtn.hidden = !query;
      }
      // Make sure the list is fully visible while searching
      if (query) {
        this.targetList.setAttribute('aria-expanded', 'true');
      }
    }

    handleKey(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.handleClear();
      }
    }

    handleClear() {
      this.input.value = '';
      if (this.clearBtn) this.clearBtn.hidden = true;
      this.filterItems('');
      this.input.focus();
    }

    filterItems(query) {
      const items = this.targetList.querySelectorAll('.facet-options-list-item');
      items.forEach((item) => {
        const labelEl =
          item.querySelector('.checkbox-facet-label-text') ||
          item.querySelector('.checkbox-facet-label');
        const text = (labelEl ? labelEl.textContent : '').toLowerCase();
        const matches = !query || text.includes(query);
        item.classList.toggle('facet-search-hidden', !matches);
      });
    }
  }

  if (!customElements.get('facet-search')) {
    customElements.define('facet-search', FacetSearch);
  }
})();
